// extracted by mini-css-extract-plugin
export var actions = "_mp-5";
export var assistantBubble = "_mp-3";
export var assistantRow = "_mp-6";
export var bubble = "_mp-0";
export var humanAvatar = "_mp-4";
export var inlineToolCard = "_mp-1";
export var userBubble = "_mp-2";